import React from 'react';
import { features } from '@data/features';
import FeatureCard from '@components/features/FeatureCard';

const WhyRideSection: React.FC = () => {
  return (
    <section className="py-12 bg-gradient-to-br from-sky-50 to-blue-50">
      <div className="container mx-auto px-4">
        <h2
          className="text-3xl font-bold mb-4 text-center text-gray-900"
          style={{ fontFamily: "'Playfair Display', serif" }}
        >
          Why Ride With Us?
        </h2>
        <p
          className="text-lg text-center text-gray-700 mb-8 max-w-3xl mx-auto"
          style={{ fontFamily: "'Poppins', sans-serif" }}
        >
          Because your vacation deserves more than just any golf cart. Our street legal carts come
          packed with everything you need to make the ride part of the{' '}
          <span className="font-bold text-sky-600">FUN</span>:
        </p>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto mb-8">
          {features.map((feature) => (
            <FeatureCard key={feature.id} feature={feature} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyRideSection;